<template>
    <div v-if="!sourceOfLeads && loading" class="dialog-loading-container">
        <v-progress-circular indeterminate color="primary"></v-progress-circular>
    </div>
    <v-card v-if="sourceOfLeads" flat class="sub-site-wrapper">
        <div class="table-statistics-wrapper">
            <v-row>
                <v-col cols="12">
                    <lead-source v-if="sourceOfLeads" />
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12">
                    <lead-source-past-7-days v-if="sourceOfLeadsPast7Days" />
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12">
                    <lead-source-past-30-days v-if="sourceOfLeadsPast30Days" />
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12">
                    <div class="statistics-text-box elevation-3">
                        <h5>Informationen zu den Statistiken:</h5>
                        <p>Es fließen nur Agenturen in die Statistik ein, die eine Stripe Subscription ID besitzen und
                            mindestens einen Slot haben.</p>
                        <p>Die Statistiken wurden am <b>{{ statisticsAge }}</b> erstellt.</p>
                    </div>
                </v-col>
            </v-row>
        </div>
    </v-card>
</template>
<script>
import LeadSource from '../charts/LeadSource.vue';
import LeadSourcePast7Days from '../charts/LeadSourcePast7Days.vue';
import LeadSourcePast30Days from '../charts/LeadSourcePast30Days.vue';
import { mapState, mapActions } from 'vuex';

export default {
    components: {
        LeadSource,
        LeadSourcePast7Days,
        LeadSourcePast30Days
    },
    created() {
        this.loadStatistics();
    },
    computed: {
        ...mapState('statistics', ['sourceOfLeads', 'loading', 'sourceOfLeadsPast7Days', 'sourceOfLeadsPast30Days', 'statisticsAge'])
    },
    methods: {
        ...mapActions('statistics', ['fetchMostRecentStatistic']),
        async loadStatistics() {
            await this.fetchMostRecentStatistic();
        },
    },
}

</script>

<style lang="scss" scoped></style>